import { CheckCircleIcon } from "@heroicons/react/solid";
import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import CompactSlotTitle from "../CompactSlotTitle";
import SlotTime from "../SlotTime";

type BookedSlotProps = {
  slot: CalendarScheduleSlotModel;
  onClick: (slot: CalendarScheduleSlotModel) => void;
};
export default function CompactBookedSlot({ slot, onClick }: BookedSlotProps) {
  return (
    <div
      role="button"
      onClick={() => onClick(slot)}
      className="p-2 w-full m-1 overflow-auto rounded bg-brandblue-400"
    >
      <p className="text-white text-xs font-medium flex items-center justify-center truncate">
        <CompactSlotTitle slot={slot} />
      </p>
    </div>
  );
}
